const initialState = {
  isShowTopSections: false,
  isShowMobileMenu: false,
  isMobile: false,
  // идёт определение города или открыто окно «Ваш город …?».
  // Пока true, остальные оверлеи (баннер куки) ждут своей очереди.
  isCityConfirmActive: false,
};

export const pageStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SHOW_TOP_SECTIONS":
      return { ...state, isShowTopSections: action.payload };
    case "SET_SHOW_MOBILE_MENU":
      return { ...state, isShowMobileMenu: action.payload };
    case "SET_CITY_CONFIRM_ACTIVE":
      return { ...state, isCityConfirmActive: action.payload };
    case "SET_IS_MOBILE":
      return { ...state, isMobile: action.payload };
    default:
      return state;
  }
};
